try {
    window._ = require('lodash');
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
    window.axios = require('axios');
    window.axios.defaults.withCredentials = true;
    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
} catch (e) {
    window.console.log(e);
}
